import React from "react";
import { colors } from "../../styles";

export const GoiHeaderBanner = () => (
  <div
    style={{
      padding: "12px 16px",
      fontSize: "12px",
      color: colors.gray600,
      background: colors.gray50,
    }}
  >
    본 포털은 장례전문업체 ㈜고이장례연구소에서 운영·관리하고 있습니다.
  </div>
);
